import { render, staticRenderFns } from "./CardAction.vue?vue&type=template&id=6b3dde6c&scoped=true"
import script from "./CardAction.vue?vue&type=script&lang=js"
export * from "./CardAction.vue?vue&type=script&lang=js"
import style0 from "./CardAction.vue?vue&type=style&index=0&id=6b3dde6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3dde6c",
  null
  
)

export default component.exports